"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _trayMenu = require("@ux/tray-menu");
var _enums = require("../enums");
var _eid = _interopRequireDefault(require("../eid"));
var _reactMintl = require("@godaddy/react-mintl");
var _link = _interopRequireDefault(require("@ux/link"));
var _chevronRight = _interopRequireDefault(require("@ux/icon/chevron-right"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* jscs:disable requireSpacesInsideJsxExpressionContainers */

/**
 * Render UserDetails in account tray after login.
 * Only used for resellers
 *
 * @Constructor
 * @class UserDetails
 * @api public
 */
class UserDetails extends _react.Component {
  constructor(props) {
    super(...arguments);
    this.eids = {
      proDashboard: (0, _eid.default)({
        key: _enums.golf.proDashboard,
        manifest: props.manifest
      }),
      visitMyAccount: (0, _eid.default)({
        key: _enums.golf.visitMyAccount,
        manifest: props.manifest
      }),
      manageAccount: (0, _eid.default)({
        key: _enums.golf.manageAccount,
        manifest: props.manifest
      }),
      accountSettings: (0, _eid.default)({
        key: _enums.golf.accountSettings,
        manifest: props.manifest
      }),
      viewPin: (0, _eid.default)({
        key: _enums.golf.viewPin,
        manifest: props.manifest
      }),
      products: (0, _eid.default)({
        key: _enums.golf.myProducts,
        manifest: props.manifest
      }),
      renewals: (0, _eid.default)({
        key: _enums.golf.renewals,
        manifest: props.manifest
      }),
      logout: (0, _eid.default)({
        key: _enums.golf.logout,
        manifest: props.manifest
      })
    };
  }
  /**
   * Show link for pro dashboard only added if a user is pro
   *
   * @returns {React.Component} Component
   * @api private
   */
  renderPro() {
    const props = this.props;
    const eids = this.eids;
    if (props.loggedIn && props.isPro) {
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
        urlArgs: props.urlArgs
      }, props.urls.pro, {
        "data-eid": eids.proDashboard
      }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: _enums.golf.proDashboard
      })));
    }
    return null;
  }
  render() {
    const props = this.props;
    const eids = this.eids;
    if (!props.loggedIn) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "account-info"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.products, {
      "data-eid": eids.manageAccount,
      className: "name ctHidden"
    }), props.name)), /*#__PURE__*/_react.default.createElement("div", {
      className: "customer-number"
    }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.shopperid
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "shopper-id ctHidden"
    }, props.shopperId), props.privateLabelType !== 14 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, " | "), /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.pinLabel
    })), /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.viewPin, {
      "data-eid": eids.viewPin,
      className: "customer-pin ctHidden"
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.viewPin
    })))), /*#__PURE__*/_react.default.createElement("ul", {
      className: "quick-links user-details-links"
    }, this.renderPro(), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.products, {
      "data-eid": eids.products
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "drop-right"
    }, /*#__PURE__*/_react.default.createElement(_chevronRight.default, null)), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.myProducts
    }))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.account, {
      "data-eid": eids.accountSettings
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "drop-right"
    }, /*#__PURE__*/_react.default.createElement(_chevronRight.default, null)), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.accountSettings
    }))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.renewals, {
      "data-eid": eids.renewals
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "drop-right"
    }, /*#__PURE__*/_react.default.createElement(_chevronRight.default, null)), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.renewals
    })))), /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.products, {
      "data-eid": eids.visitMyAccount,
      "data-version": "2400",
      className: "ux-button ux-button-secondary account-visit"
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.visitMyAccount
    })), /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.sso.logout, {
      "data-eid": eids.logout,
      className: "logout-link"
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.logout
    }))));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */
UserDetails.propTypes = {
  name: _propTypes.default.string,
  shopperId: _propTypes.default.string,
  loggedIn: _propTypes.default.bool,
  isPro: _propTypes.default.bool,
  market: _propTypes.default.string.isRequired,
  messages: _propTypes.default.object.isRequired,
  privateLabelId: _propTypes.default.number,
  privateLabelType: _propTypes.default.number,
  manifest: _propTypes.default.string,
  urlArgs: _propTypes.default.object,
  urls: _propTypes.default.object
};
var _default = exports.default = UserDetails;